export default __webpack_public_path__ + "static/media/image-product.26c0ce53.jpg";